import { CalendarCheck, MessageCircle, Phone } from "lucide-react";
import { BUSINESS, WA_MESSAGES, createWhatsAppLink } from "@/config/business";

const StickyMobileCta = () => (
  <nav
    data-testid="mobile-sticky-cta"
    aria-label="Quick booking actions"
    className="fixed inset-x-0 bottom-0 z-50 border-t border-[#E7E2DA] bg-white/95 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-[0_-8px_25px_rgba(0,0,0,0.08)] backdrop-blur-md md:hidden"
  >
    <div className="grid grid-cols-3 gap-2">
      <a
        href={BUSINESS.tel}
        data-testid="mobile-bottom-bar-call-btn"
        aria-label={`Call GK Wellness on ${BUSINESS.phoneIntl}`}
        className="inline-flex min-h-[48px] items-center justify-center gap-1.5 rounded-full border border-[#1C1917]/25 text-sm font-semibold text-[#1C1917] transition-colors active:bg-[#F4EFEA]"
      >
        <Phone className="h-4 w-4" aria-hidden="true" />
        Call
      </a>
      <a
        href={createWhatsAppLink(WA_MESSAGES.general)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-bottom-bar-whatsapp-btn"
        aria-label="Chat with GK Wellness on WhatsApp"
        className="inline-flex min-h-[48px] items-center justify-center gap-1.5 rounded-full bg-[#22a355] text-sm font-semibold text-white transition-colors active:bg-[#1e9e4f]"
      >
        <MessageCircle className="h-4 w-4" aria-hidden="true" />
        WhatsApp
      </a>
      <a
        href={createWhatsAppLink(WA_MESSAGES.hero)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-bottom-bar-book-btn"
        aria-label="Book an appointment with GK Wellness on WhatsApp"
        className="inline-flex min-h-[48px] items-center justify-center gap-1.5 rounded-full bg-[#C5A059] text-sm font-semibold text-white transition-colors active:bg-[#B38D46]"
      >
        <CalendarCheck className="h-4 w-4" aria-hidden="true" />
        Book
      </a>
    </div>
  </nav>
);

export default StickyMobileCta;
